import React from 'react';
import { RenderElementProps } from 'slate-react';
import { CORRECT_ANSWER, CORRECT_ANSWERS } from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const CorrectAnswerElement = dynamicEditorComponent(() =>
  import('./components/CorrectAnswerElement').then((mod) => mod.CorrectAnswerElement)
);
const CorrectAnswersElement = dynamicEditorComponent(() =>
  import('./components/CorrectAnswersElement').then((mod) => mod.CorrectAnswersElement)
);

export const renderElementCorrectAnswers = (options?: any) => (props: RenderElementProps) => {
  const { element } = props;

  switch (element.type) {
    case CORRECT_ANSWERS:
      return <CorrectAnswersElement {...props} />;

    case CORRECT_ANSWER:
      return <CorrectAnswerElement {...props} />;

    default:
      return undefined;
  }
};
